const SidebarQuestions = ({ width = "17", height = "19" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2083 0.833344H2.79167C2.28333 0.833344 1.79582 1.0265 1.43638 1.37031C1.07693 1.71413 0.875 2.18045 0.875 2.66668V15.5C0.875 15.9862 1.07693 16.4526 1.43638 16.7964C1.79582 17.1402 2.28333 17.3333 2.79167 17.3333H6.625L9.5 20.0833L12.375 17.3333H16.2083C17.2625 17.3333 18.125 16.5083 18.125 15.5V2.66668C18.125 1.65834 17.2625 0.833344 16.2083 0.833344ZM16.2083 15.5H11.5796L11.0142 16.0408L9.5 17.4892L7.97625 16.0317L7.42042 15.5H2.79167V2.66668H16.2083V15.5ZM8.54167 12.75H10.4583V14.5833H8.54167V12.75ZM9.5 5.41668C10.5542 5.41668 11.4167 6.24168 11.4167 7.25001C11.4167 9.08334 8.54167 8.85418 8.54167 11.8333H10.4583C10.4583 9.77084 13.3333 9.54168 13.3333 7.25001C13.3333 5.22418 11.6179 3.58334 9.5 3.58334C7.38208 3.58334 5.66667 5.22418 5.66667 7.25001H7.58333C7.58333 6.24168 8.44583 5.41668 9.5 5.41668Z"
        fill="white"
      />
    </svg>
  );
};
export default SidebarQuestions;
